import { OffersPromoRepository } from "../Repository/OffersPromoRepository";
import { OfferState } from '../Model/OfferState';



export interface UpdateStateOfferUseCase {
    invoke: (data: OfferState) => Promise<boolean>;
  }
  
  export class UpdateStateOffer implements UpdateStateOfferUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(data: OfferState){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateStateOffer(data);
        return update;
    }
  }